import React from 'react';
import { Link } from 'react-router-dom';
import type { BlogPost } from '../../utils/blogData';
import styles from './BlogCard.module.css';

interface BlogCardProps {
  post: BlogPost;
}

const BlogCard: React.FC<BlogCardProps> = ({ post }) => {
  return (
    <article className={styles.card}>
      <Link to={`/blog/${post.slug}`} className={styles.link}>
        <img src={post.image} alt={post.title} className={styles.image} />
        <div className={styles.content}>
          <h3 className={styles.title}>{post.title}</h3>
          <p className={styles.excerpt}>{post.excerpt}</p>
          <span className={styles.date}>{new Date(post.date).toLocaleDateString()}</span>
        </div>
      </Link>
    </article>
  );
};

export default BlogCard;
